<div class="input-group input-group-sm">
  <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="col q-input-border q-bo" aria-label="Small"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  <div *ngFor="let button of input?.MainElementList?.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="OnButtonClick(button);"
            [title]="button?.Tooltip ? button?.Tooltip : ''"
            [disabled]="input.MainElementList[0].Disabled || button.Disabled">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
</div>
